import Button from './_button.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'
import Hideable from './_hideable.js'

export default {
  name: 'Checkbox',
  values: {
    container: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            minHeight: '40px',
            minWidth: '40px',
          },
        },
      },
    },
    checkButtonImageContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          minWidth: '16px',
          maxWidth: '16px',
          minHeight: '16px',
          maxHeight: '16px',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    label: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    checkButtonLabelContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    icon: {
      configSet: Image,
      configValues: {
        src: 'check',
        style: {
          minWidth: '8px',
          minHeight: '8px',
          pointerEvents: 'none',
        },
      },
    },
    $mixin: [
      {
        configSet: Hideable,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
